import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=b5c4223e&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"
import style0 from "./Detail.vue?vue&type=style&index=0&id=b5c4223e&prod&scoped=true&lang=css"
import style2 from "./Detail.vue?vue&type=style&index=2&id=b5c4223e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c4223e",
  null
  
)

export default component.exports